import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompleterService, CompleterData } from 'ng2-completer';
import { DocumentsService } from 'src/app/services/documents.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { GeneralService } from 'src/app/services/general.service';
import { LicenciaMedicaService } from 'src/app/services/licencia-medica.service';
import Swal from 'sweetalert2';
import { YappService } from 'src/app/services/yapp.service';
import { UsuarioService } from 'src/app/services/usuario.service';


interface YappSelectedItem {
  clinicalIds: number[];
  commercialIds: number[];
  title: string;
  subtitle: string;
  indication: string;
}
@Component({
  selector: 'app-documentos-medicina-general',
  templateUrl: './documentos-medicina-general.component.html',
  styleUrls: ['./documentos-medicina-general.component.css']
})
export class DocumentosMedicinaGeneralComponent implements OnInit {
  @Input() consulta: any = {};
  @Input() selectedView: string = '';
  @Output() selectedTabChange = new EventEmitter<string>();

  @Input() set activeTab(value: string) {
    if (value) {
      this.selectedTab = value;   // sincronizamos el tab interno con el padre
    }
  }
  modalActual: string | null = null;

  usuario: any = {};

  isLoading = true;

  tiposDocumentosTabs = [
    { key: 'Anamnesis', icon: 'fi fi-rr-stethoscope' },
    { key: 'Diagnósticos e indicaciones', icon: 'fi fi-rr-doctor' }, // ajusta si hace falta
    { key: 'Recetas', icon: 'fi fi-rr-document-signed' },
    { key: 'Certificados', icon: 'fi fi-rr-document' },
    { key: 'Órdenes de exámenes', icon: 'fi fi-rr-document' },
    { key: 'Licencias', icon: 'fi fi-rr-document' },
    { key: 'Mascota', icon: 'fi fi-rr-paw' },
    { key: 'Otros documentos', icon: 'fi fi-rr-folder' },
  ];

  // selectedTab sigue siendo string (el key)


  documentosAdjuntados: string[] = [
    'Por el paciente',
    'Por los tratantes'
  ]

  selectedTab: string = 'Anamnesis';

  selectedTabDoc: 'Por el paciente' | 'Por los tratantes' = 'Por el paciente'


  documentos: any;


  // Campos
  anamnesisText: string = '';
  diagnosticosText: string = '';
  prescriptionText: string = '';
  certificadosText: string = '';
  ordersText: string = '';
  licensesText: string = '';
  documentsText: string = '';

  //edit

  editandoAnamnesis: boolean = false;
  editandoDiagnosticos: boolean = false;
  editandoCertificados: boolean = false;
  editandoOrdenes: boolean = false;
  editandoLicencias: boolean = false;
  editandoMascota: boolean = false;
  idEditando: any = null;

  causales: any;
  id_causal: any = '';


  //add

  agregandoAnamnesis: boolean = false;
  agregandoDiagnostico: boolean = false;
  agregandoReceta: boolean = false;
  agregandoCertificado: boolean = false;
  agregandoOrden: boolean = false;
  agregandoLicencia: boolean = false;
  agregandoMascota: boolean = false;

  // Documentos generados
  anamnesisGuardadas: any[] = [];
  diagnosticosGuardados: any[] = [];
  recetasGuardadas: any[] = [];
  certificadosGuardados: any[] = [];
  ordenesGuardadas: any[] = [];
  diagnosticosParaLicencia: any[] = [];

  archivos_paciente: any = [];
  archivos_consulta: any = [];



  diagnosticoSeleccionadoId: any = null;
  certificadoEditandoId: any = null;

  // Diagnóstico
  diagnosticos: CompleterData;

  diagnosticos_data: any = [];
  detalleDiagnostico: string = '';
  indicacionDiagnostico: string = '';

  diagnostico_selected: any = {};
  certificado_selected: any = {};
  examen_selected: any = {};
  diagnosticoAEliminar: any = null;

  searchStrDia: string;

  // Recetas
  recetas: any;
  recetasFiltradas: any[] = [];
  id_receta: any = '';
  check_firma: boolean = false;
  prescriptionAEliminar: any = null;
  id_requerimiento: any;


  // ordenes
  examenes: any;
  examen_elegido: any = {};
  id_exam: any = '';

  //licencias
  licenciaFechaInicio: string = '';          // texto/fecha: dd/mm/yyyy o como esperes
  licenciaDiasReposo: number | null = null;
  licenciaTipo: any = '';                    // med_lev_typ_id
  licenciaRutHijo: string = '';
  licenciaFechaNacimientoHijo: string = '';
  licenciaDiagnosticoId: any = '';

  tiposLicencia: any[] = [];
  licenciasGuardadas: any[] = [];

  //mascota
  mascotasGuardadas: any[] = [];
  mascotaNombrePaciente: string = '';
  mascotaEdad: string = '';
  mascotaEspecie: string = '';
  mascotaRaza: string = '';
  mascotaPeso: string = '';
  mascotaSexo: 'Macho' | 'Hembra' | null = null;
  mascotaEsterilizado: 'Si' | 'No' | null = null;
  mascotaComentario: string = '';

  documentoAEliminar: any = null;
  tipoDocumentoAEliminar: 'diagnostico' | 'receta' | 'certificado' | 'orden' | 'otro' | 'mascota' | null = null;

  // ===== Adjuntos (doctor) =====
  agregandoDocumento = false;
  nombre_doc = '';
  doc: File | null = null;
  doc_permitido = true;
  doc_supera_peso = false;
  readonly maxPesoBytes = 20 * 1024 * 1024; // 20 MB
  readonly tiposPermitidos = ['application/pdf', 'image/jpeg', 'image/png'];

  tiposDeDocumentos: any[] = [];


  // =====================
  // YAPP AUTOCOMPLETE
  // =====================
  yappCommune: number = 13101;
  yappQuery: string = '';
  yappResults: any[] = [];
  yappLoading = false;
  yappShowDropdown = false;

  private yappDebounceTimer: any = null;
  private yappReqId = 0;
  yappSelectedItems: YappSelectedItem[] = [];

  // NUEVO: región/comuna YAPP
  regionesYapp: any[] = [];
  comunasYapp: any[] = [];

  selectedRegionId: number | null = null;
  selectedComunaId: number | null = null;

  selectedRegionObj: any = null;
  selectedComunaObj: any = null;
  constructor(
    private _fichaMedicaServices: FichaMedicaService,
    public _generalServices: GeneralService,
    private _completerService: CompleterService,
    private _documentServices: DocumentsService,
    private _licenciaService: LicenciaMedicaService,
    private _yappService: YappService,
    private _usuarioService: UsuarioService



  ) {

    this.getListarConDiagnostic()
    this.getListarExamType();
    this.usuario = new EncriptacionService().getUserInfo(); // <-- para doc_lme
    this.getListarConCausal();

  }


  async ngOnInit(): Promise<void> {
    if (!this.selectedTab) {
      this.selectedTab = 'Anamnesis';
    }

    if (this.consulta && this.consulta.id_consulta) {
      this.listar_documentos();
    }

    this.getDocumentos();
    this.listar_archivos_consulta();
    this.getListarPrescriptionType();
    this.postListMedicalLeaveType();
    this.getListarTipoDocumentosPacientes();

    await this.initRegionComunaYapp();

    this.yappCommune = this.resolveCommune();
  }

  ngOnChanges() {
    if (this.consulta && this.consulta.id_consulta) {
      //console.log("Existe consulta");
      this.listar_documentos();
      this.listar_archivos_consulta();
    }
  }

  onTabClick(tabKey: string): void {
    if (this.selectedView === 'consulta') {

      this.selectedTab = tabKey;

    }
    else {

      this.selectedTab = tabKey;
      this.selectedTabChange.emit(tabKey); // 👈 aquí avisamos al padre
    }
  }

  getDocumentos() {
    this._fichaMedicaServices.getListarFichaConsulta(this.consulta)
      .then((results: any) => {
        this.documentos = results;

        this.anamnesisGuardadas = this.formatFiles(this.documentos.anamnesis || []);
        this.diagnosticosGuardados = this.formatFiles(this.documentos.diagnostics || []);
        // console.log(this.diagnosticosGuardados);

        this.recetasGuardadas = this.formatFiles(this.documentos.prescriptions || []);
        // console.log(this.recetasGuardadas);

        this.certificadosGuardados = this.formatFiles(this.documentos.certificados || []);
        this.ordenesGuardadas = this.formatFiles(this.documentos.orders || []);
        // console.log(this.ordenesGuardadas);

        this.licenciasGuardadas = this.formatFiles(this.documentos.medical_license || []);
        // console.log(this.licenciasGuardadas);

        this.diagnosticosParaLicencia = (this.diagnosticosGuardados || []).filter(d => this.tieneCie10(d));

        this.mascotasGuardadas = this.formatFiles(this.documentos.docsMascotas || []);
        console.log('Mascotas guardadas:', this.mascotasGuardadas);
      })
      .catch(error => {
        console.log(error);
      });
  }


  private getCie10Code(d: any): string | null {
    // Cubre nombres posibles que he visto en tu código/back
    return (
      d?.dia_cie10 ??
      d?.diag_det_his_dia_cie10 ??
      d?.dia_det_his_dia_cie10 ??
      d?.cie10 ??
      null
    );
  }

  private tieneCie10(d: any): boolean {
    const code = this.getCie10Code(d);
    return !!(code && String(code).trim());
  }
  private formatFiles(lista: any[]): any[] {
    if (!Array.isArray(lista)) return [];

    let ind = 1;
    return lista.map(file => {
      if (file?.file_name) {
        // Genera correlativo tipo 01, 02, 03...
        const ind_st = (100 + ind).toString().substring(1);
        file.file_name_desc = file.file_name.replace('XX', ind_st);
        ind++;
      }
      return file;
    });
  }


  postListMedicalLeaveType() {
    this._licenciaService.postListMedicalLeaveType()
      .then((result: any) => this.tiposLicencia = result || [])
      .catch(() => this.tiposLicencia = []);
  }

  getListarConCausal() {
    this._fichaMedicaServices.getListarConCausal()
      .then(results => {
        this.causales = results;
        // console.log(this.causales);
      });
  }

  getListarTipoDocumentosPacientes() {
    this._documentServices.getListarTipoDocumentosPacientes()
      .then((results: any) => {
        this.tiposDeDocumentos = results;
        // console.log(this.tiposDeDocumentos);
      })
      .catch(error => console.log(error));
  }

  // ANAMNESIS


  guardarAnamnesis() {
    if (this.editandoAnamnesis && !this.id_causal) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Selecciona un motivo de modificación.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      return;
    }

    const body: any = {
      med_con_anamnesis: this.anamnesisText,
      med_con_id: this.consulta.med_con_id
    };
    if (this.editandoAnamnesis) body.causal = this.id_causal;

    this._fichaMedicaServices.postUpdateMedicalAnamnesis(body)
      .then(() => {
        this.editandoAnamnesis = false;
        this.agregandoAnamnesis = false;
        this.id_causal = null;  // <<< limpiar
        this.anamnesisText = '';
        this.getDocumentos();
      })
      .catch(err => console.log(err));
  }

  abrirAgregarAnamnesis() {
    this.editandoAnamnesis = false;
    this.agregandoAnamnesis = true;
    this.id_causal = null; // <<< limpiar
    this.anamnesisText = '';
  }

  cancelarAnamnesis() {
    this.editandoAnamnesis = false;
    this.agregandoAnamnesis = false;
    this.id_causal = null; // <<< limpiar
    this.anamnesisText = '';
  }

  editarAnamnesis(item: any) {
    this.anamnesisText = item.med_con_his_anamnesis;
    this.editandoAnamnesis = true;
    this.agregandoAnamnesis = false;
  }



  //DIAGNOSTICOS


  getListarConDiagnostic() {
    this._fichaMedicaServices.getListarConDiagnostic().then(results => {
      this.diagnosticos_data = results;
      for (let dia of this.diagnosticos_data.diagnosticos) {
        dia.descripcion = dia.dia_cie10 + ': ' + dia.dia_name;
      }
      this.diagnosticos = this._completerService.local(this.diagnosticos_data.diagnosticos, 'descripcion', 'descripcion')
    });
  }

  guardarDiagnosticos() {
    // si estoy editando, motivo es obligatorio
    if (this.editandoDiagnosticos && !this.id_causal) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Selecciona un motivo de modificación.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      }); return;
    }

    // ✅ Solo obligatorios: detalle y indicaciones (CIE-10 opcional)
    if (!this.detalleDiagnostico?.trim() || !this.indicacionDiagnostico?.trim()) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Faltan campos obligatorios</h1><br>'
      });
      return;
    }

    const params = {
      causal: this.editandoDiagnosticos ? this.id_causal : null,
      diag_det_his_dia_det_id: this.idEditando || '',
      dia_det_med_con_id: this.consulta.med_con_id,
      // ✅ CIE-10 opcional
      dia_det_dia_id: this.diagnostico_selected?.dia_id || null,
      dia_det_diagnostic_detail: this.detalleDiagnostico,
      indicacion: this.indicacionDiagnostico,
    };

    this.modalCargando();
    this._fichaMedicaServices.postCreateDiagnostic(params)
      .then(() => {
        this.modalAgregadoExitoso();
        this.getDocumentos();
        // limpiar estados
        this.editandoDiagnosticos = false;
        this.agregandoDiagnostico = false;
        this.idEditando = null;
        this.id_causal = null;
        this.detalleDiagnostico = '';
        this.indicacionDiagnostico = '';
        this.searchStrDia = '';
        this.diagnostico_selected = null;
      })
      .catch(() => this.modalErrorDocumento());
  }

  private setDiagnosticoDesdeItem(item: any) {
    if (!this.diagnosticos_data?.diagnosticos?.length) return;

    // Intenta por id; si no, por CIE10 o nombre
    const prevId = item?.dia_id ?? item?.diag_det_his_dia_id ?? item?.dia_det_dia_id ?? null;
    const prevCode = item?.dia_cie10 ?? item?.diag_det_his_dia_cie10 ?? null;
    const prevName = item?.dia_name ?? item?.diag_det_his_dia_name ?? null;

    const lista = this.diagnosticos_data.diagnosticos;

    let diag = null;
    if (prevId != null) {
      diag = lista.find((d: any) => String(d.dia_id) === String(prevId));
    }
    if (!diag && prevCode) {
      diag = lista.find((d: any) => d.dia_cie10 === prevCode);
    }
    if (!diag && prevName) {
      diag = lista.find((d: any) => d.dia_name === prevName);
    }

    if (diag) {
      // lo que el completer muestra y matchea (tú lo armaste como "CIE10: Nombre")
      this.searchStrDia = diag.descripcion;
      // objeto seleccionado para guardar (necesitas .dia_id al guardar)
      this.diagnostico_selected = diag;
    } else {
      // si no encontramos, al menos no borres lo que había
      this.searchStrDia = '';
      this.diagnostico_selected = null;
    }
  }


  abrirAgregarDiagnostico() {
    this.agregandoDiagnostico = true;
    this.editandoDiagnosticos = false;
    this.idEditando = null;
    this.id_causal = ''; // <<< limpiar
    this.detalleDiagnostico = '';
    this.indicacionDiagnostico = '';
    this.searchStrDia = '';
    this.diagnostico_selected = null;
  }

  cancelarDiagnostico() {
    this.agregandoDiagnostico = false;
    this.editandoDiagnosticos = false;
    this.idEditando = null;
    this.id_causal = ''; // <<< limpiar
    this.detalleDiagnostico = '';
    this.indicacionDiagnostico = '';
    this.searchStrDia = '';
    this.diagnostico_selected = null;
  }


  editarDiagnostico(item: any) {
    this.detalleDiagnostico = item.diag_det_his_diagnostic_detail;
    this.indicacionDiagnostico = item.diag_det_his_indication_detail;

    this.editandoDiagnosticos = true;
    this.agregandoDiagnostico = false;
    this.idEditando = item.dia_det_id;

    // ★ Prefija el CIE10 previamente guardado
    this.setDiagnosticoDesdeItem(item);
  }


  cancelarEdicionDiagnostico() {
    this.editandoDiagnosticos = false;
    this.detalleDiagnostico = '';
    this.indicacionDiagnostico = '';
    this.searchStrDia = '';
    this.diagnostico_selected = null;
    this.idEditando = null;
  }


  eliminarDocumento() {
    if (!this.documentoAEliminar || !this.tipoDocumentoAEliminar) return;

    this.modalCargando();

    if (this.tipoDocumentoAEliminar === 'diagnostico') {
      this._fichaMedicaServices.postDeleteDiagnostic(this.documentoAEliminar.dia_det_id)
        .then(() => {
          this.getDocumentos();
          this.cerrarModal();
        })
        .catch(() => {
          this.modalErrorDocumento();
        });
    }

    if (this.tipoDocumentoAEliminar === 'receta') {
      this._fichaMedicaServices.postDeletePrescription(this.documentoAEliminar.pre_his_pre_id)
        .then(() => {
          this.getDocumentos();
          this.cerrarModal();
        })
        .catch(() => {
          this.modalErrorDocumento();
        });
    }
    if (this.tipoDocumentoAEliminar === 'certificado') {
      this._fichaMedicaServices.postDeleteOrder(this.documentoAEliminar.med_ord_id)
        .then(() => {
          this.getDocumentos();
          this.cerrarModal();
        })
        .catch(() => {
          this.modalErrorDocumento();
        });
    }
    if (this.tipoDocumentoAEliminar === 'orden') {
      this._fichaMedicaServices.postDeleteOrder(this.documentoAEliminar.med_ord_id)
        .then(() => {
          this.getDocumentos();
          this.cerrarModal();
        })
        .catch(() => {
          this.modalErrorDocumento();
        });

    }
    if (this.tipoDocumentoAEliminar === 'mascota') {
      this._fichaMedicaServices.postDeleteDocsMascota(this.documentoAEliminar.doc_masc_id)
        .then(() => {
          this.getDocumentos();
          this.cerrarModal();
        })
        .catch(() => {
          this.modalErrorDocumento();
        });

    }
    if (this.tipoDocumentoAEliminar === 'otro') {
      this._documentServices.postEliminarArchivo(this.documentoAEliminar.att_name)
        .then(() => {
          this.listar_archivos_consulta();
          this.cerrarModal();
        })
        .catch(() => {
          this.modalErrorDocumento();
        });

    }
  }



  changeDiagnostico($event) {
    if ($event) {
      this.diagnostico_selected = $event.originalObject;
    }
    //console.log(this.diagnostico_selected);

  }

  // RECETAS

  getListarPrescriptionType() {
    this._fichaMedicaServices.getListarPrescriptionType().then(results => {
      this.recetas = results;

      const todas = this.recetas?.recetas || [];

      // Si el usuario está enrolado, ve todos los tipos
      if (this.usuario?.doc_enrolled) {
        this.recetasFiltradas = todas;
      } else {
        // Si NO está enrolado, ocultar pre_typ_id 2 y 3
        this.recetasFiltradas = todas.filter((r: any) => {
          const id = Number(r.pre_typ_id); // por si viene como string
          return id !== 2 && id !== 3;
        });
      }
    });
  }

  abrirAgregarReceta() {
    this.agregandoReceta = true;
    this.id_receta = '';
    this.prescriptionText = '';
    this.check_firma = false;
    this.resetYappState();
  }

  cancelarReceta() {
    this.agregandoReceta = false;
    this.id_receta = '';
    this.prescriptionText = '';
    this.check_firma = false;
    this.resetYappState();
  }

  // tras guardar, cerramos el formulario y refrescamos
  postCreatePrescription() {
    const textoFinal = this.buildPrescriptionText();

    if (!this.id_receta || !textoFinal?.trim()) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Faltan campos obligatorios</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      return;
    }

    // Validación opcional para YAPP
    if (this.mostrarBuscadorYapp()) {
      const ubicacionYapp = this.getUbicacionYappFinal();

      if (!ubicacionYapp.reg_id || !ubicacionYapp.com_id || !ubicacionYapp.code_yapp) {
        Swal.fire({
          allowOutsideClick: false,
          html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
            ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Debes seleccionar región y comuna válidas</h1><br>',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000
        });
        return;
      }
    }

    const idsYapp = this.getYappSelectedIds();
    const isYapp = idsYapp.clinicos.length > 0 || idsYapp.comerciales.length > 0;
    const ubicacionYapp = this.getUbicacionYappFinal();

    const params = {
      causal: this.id_causal,
      pre_pre_typ_id: this.id_receta,
      pre_his_pre_id: '',
      pre_prescription: textoFinal,
      pre_indication: textoFinal,
      pre_med_con_id: this.consulta.med_con_id,
      ids_yapp: idsYapp,
      is_yapp: isYapp,
      code_yapp: ubicacionYapp.code_yapp,
      reg_id: ubicacionYapp.reg_id,
      reg_name: ubicacionYapp.reg_name,
      com_id: ubicacionYapp.com_id,
      com_name: ubicacionYapp.com_name
    };

    this.modalCargando();

    const req = this.check_firma
      ? this._fichaMedicaServices.postFirmaDocumento(params)
      : this._fichaMedicaServices.postCreatePrescription(params);

    req.then(() => {
      this.modalAgregadoExitoso();
      this.getDocumentos();
      this.cancelarReceta();
    })
      .catch(err => {
        this.modalErrorDocumento(err?.error?.msg || 'Ocurrió un error al guardar la receta.');
      });
  }

  eliminarReceta() {
    if (!this.prescriptionAEliminar) return;

    this.modalCargando();
    this._fichaMedicaServices.postDeletePrescription(this.prescriptionAEliminar.pre_his_pre_id)
      .then(() => {
        this.getDocumentos();
        this.cerrarModal();
        this.prescriptionAEliminar = null;
      })
      .catch(error => {
        console.log(error);
        this.modalErrorDocumento();
      });
  }

  guardarCertificado() {
    if (this.editandoCertificados && !this.id_causal) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Selecciona un motivo de modificación.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      }); return;
    }
    if (!this.certificadosText?.trim()) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Debes ingresar el texto del certificado.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      return;
    }

    const params: any = {
      causal: this.editandoCertificados ? this.id_causal : null,
      med_ord_exa_typ_id: '',
      id_tel_medical_order: this.idEditando || '',
      med_ord_med_ord_typ_id: 2,
      med_ord_comment: this.certificadosText,
      med_ord_tel_med_con_id: this.consulta.med_con_id
    };

    this.modalCargando();
    this._fichaMedicaServices.postCreateOrden(params)
      .then(() => {
        this.modalAgregadoExitoso();
        this.getDocumentos();
        this.cancelarCertificado();
        this.id_causal = null; // <<< limpiar
      })
      .catch(e => this.modalErrorDocumento(e?.error?.msg || 'Error al guardar el certificado'));
  }

  abrirAgregarCertificado() {
    this.agregandoCertificado = true;
    this.editandoCertificados = false;
    this.idEditando = null;
    this.id_causal = null; // <<< limpiar
    this.certificadosText = '';
  }

  cancelarCertificado() {
    this.agregandoCertificado = false;
    this.editandoCertificados = false;
    this.idEditando = null;
    this.id_causal = null; // <<< limpiar
    this.certificadosText = '';
  }


  editarCertificado(item: any) {
    this.certificadosText = item.med_ord_his_comment;
    this.editandoCertificados = true;
    this.agregandoCertificado = false;
    this.idEditando = item.med_ord_id;
  }

  // Asegúrate de cerrar el formulario al guardar (llamando a cancelarCertificado())


  // ORDENES DE EXAMENES

  getListarExamType() {
    this._fichaMedicaServices.getListarExamType().then(results => {
      this.examenes = results;
    });
  }

  traerExamen() {
    //console.log(this.examenes);
    for (let index = 0; index < this.examenes.examenes.length; index++) {
      const element = this.examenes.examenes[index];
      if (element.exa_typ_id == this.id_exam) {
        this.examen_elegido = element;
      }
    }
    //console.log(this.examen_elegido);
  }


  guardarOrdenExamen() {
    if (this.editandoOrdenes && !this.id_causal) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Selecciona un motivo de modificación.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      }); return;
    }
    if (!this.id_exam) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Debes seleccionar un examen.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      return;

    }
    if (!this.ordersText?.trim()) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Debes ingresar una observación.</h1><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      return;
    }

    const params: any = {
      causal: this.editandoOrdenes ? this.id_causal : null,
      med_ord_exa_typ_id: this.id_exam,
      id_tel_medical_order: this.idEditando || '',
      med_ord_med_ord_typ_id: 3,
      med_ord_comment: this.ordersText,
      med_ord_tel_med_con_id: this.consulta.med_con_id
    };

    this.modalCargando();
    this._fichaMedicaServices.postCreateOrden(params)
      .then(() => {
        this.modalAgregadoExitoso();
        this.getDocumentos();
        this.cancelarOrden();
        this.id_causal = null; // <<< limpiar
      })
      .catch(e => this.modalErrorDocumento(e?.error?.msg || 'Error al guardar la orden'));
  }

  abrirAgregarOrden() {
    this.agregandoOrden = true;
    this.editandoOrdenes = false;
    this.idEditando = null;
    this.id_causal = null; // <<< limpiar
    this.id_exam = '';
    this.ordersText = '';
    this.examen_selected = null;
  }

  cancelarOrden() {
    this.agregandoOrden = false;
    this.editandoOrdenes = false;
    this.idEditando = null;
    this.id_causal = null; // <<< limpiar
    this.id_exam = '';
    this.ordersText = '';
    this.examen_selected = null;
  }


  // Mantén tu editar existente, solo asegura estados
  editarOrdenExamen(item: any) {
    this.ordersText = item.med_ord_his_comment;
    this.id_exam = '';                  // si deseas precargar, puedes mapear el id del item a exa_typ_id
    this.editandoOrdenes = true;
    this.agregandoOrden = false;
    this.idEditando = item.med_ord_id;
  }

  // Al guardar, cerrar el formulario como en las otras secciones

  //Mascotas

 // Mascotas

abrirAgregarMascota() {
  this.agregandoMascota = true;
  this.editandoMascota = false;
  this.idEditando = null;
  this.id_causal = null;
  this.resetMascotaForm();
}

cancelarMascota() {
  this.agregandoMascota = false;
  this.editandoMascota = false;
  this.idEditando = null;
  this.id_causal = null;
  this.resetMascotaForm();
}

private resetMascotaForm() {
  this.mascotaNombrePaciente = '';
  this.mascotaEdad = '';
  this.mascotaEspecie = '';
  this.mascotaRaza = '';
  this.mascotaPeso = '';
  this.mascotaSexo = null;
  this.mascotaEsterilizado = null;
  this.mascotaComentario = '';
}

editarMascota(item: any) {
  this.agregandoMascota = false;
  this.editandoMascota = true;
  this.id_causal = null;

  this.idEditando = item.doc_masc_id || item.doc_masc_his_doc_masc_id || null;

  this.mascotaNombrePaciente =
    item.nombre_mascota ||
    item.nombre_paciente ||
    item.pre_his_nombre_paciente ||
    item.doc_masc_nombre_mascota ||
    '';

  this.mascotaEdad =
    item.edad ||
    item.pre_his_edad ||
    item.doc_masc_edad ||
    '';

  this.mascotaEspecie =
    item.especie ||
    item.pre_his_especie ||
    item.doc_masc_especie ||
    '';

  this.mascotaRaza =
    item.raza ||
    item.pre_his_raza ||
    item.doc_masc_raza ||
    '';

  this.mascotaPeso =
    item.peso ||
    item.pre_his_peso ||
    item.doc_masc_peso ||
    '';

  this.mascotaSexo =
    item.sexo ||
    item.pre_his_sexo ||
    item.doc_masc_sexo ||
    null;

  this.mascotaEsterilizado =
    item.esterilizado ||
    item.pre_his_esterilizado ||
    item.doc_masc_esterilizado ||
    null;

  this.mascotaComentario =
    item.doc_masc_his_comment ||
    item.doc_masc_comment ||
    item.comentario ||
    '';
}

guardarMascota() {
  if (this.editandoMascota && !this.id_causal) {
    Swal.fire({
      allowOutsideClick: false,
      html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
        ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Selecciona un motivo de modificación.</h1><br>',
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000
    });
    return;
  }

  if (
    !this.mascotaNombrePaciente?.trim() ||
    !this.mascotaEdad?.trim() ||
    !this.mascotaEspecie?.trim() ||
    !this.mascotaRaza?.trim() ||
    !this.mascotaPeso?.trim() ||
    !this.mascotaSexo ||
    !this.mascotaEsterilizado
  ) {
    Swal.fire({
      allowOutsideClick: false,
      html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
        ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Faltan campos obligatorios.</h1><br>',
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000
    });
    return;
  }

  const params: any = {
    causal: this.editandoMascota ? this.id_causal : null,
    doc_masc_med_con_id: this.consulta.med_con_id,
    id_doc_masc_id: this.editandoMascota ? this.idEditando : '',
    nombre_mascota: this.mascotaNombrePaciente,
    edad: this.mascotaEdad,
    especie: this.mascotaEspecie,
    raza: this.mascotaRaza,
    sexo: this.mascotaSexo,
    peso: this.mascotaPeso,
    esterilizado: this.mascotaEsterilizado,
    doc_masc_comment: this.mascotaComentario,
    pre_med_con_id: this.consulta.med_con_id,


  };

  this.modalCargando();

  this._fichaMedicaServices.postCreateDocsMascota(params)
    .then(() => {
      this.modalAgregadoExitoso();
      this.getDocumentos();
      this.cancelarMascota();
    })
    .catch(e => {
      this.modalErrorDocumento(e?.error?.msg || 'Error al guardar la mascota');
    });
}




  // LICENCIAS

  abrirAgregarLicencia() {
    this.agregandoLicencia = true;
    // this.editandoLicencia = false;
    this.resetLicenciaForm();
  }

  cancelarLicencia() {
    this.agregandoLicencia = false;
    // this.editandoLicencia = false;
    this.resetLicenciaForm();
  }

  private resetLicenciaForm() {
    this.licenciaFechaInicio = '';
    this.licenciaDiasReposo = null;
    this.licenciaTipo = '';
    this.licenciaRutHijo = '';
    this.licenciaFechaNacimientoHijo = '';
    this.licenciaDiagnosticoId = '';
  }

  private verificarDatosLicencia(): boolean {
    const fIni = this.licenciaFechaInicio;
    const fHijo = this.licenciaFechaNacimientoHijo;

    if (!fIni) {
      this.modalErrorDocumento('Fecha de inicio inválida.');
      return false;
    }
    if (!this.licenciaDiasReposo || this.licenciaDiasReposo < 1) {
      this.modalErrorDocumento('Días de reposo inválidos.');
      return false;
    }
    if (!this.licenciaDiagnosticoId) {
      this.modalErrorDocumento('Debes seleccionar un diagnóstico.');
      return false;
    }
    if (!this.licenciaTipo) {
      this.modalErrorDocumento('Debes seleccionar un tipo de licencia.');
      return false;
    }
    if (this.licenciaRutHijo && !this._generalServices.validaRut(this.licenciaRutHijo)) {
      this.modalErrorDocumento('RUT del hijo inválido.');
      return false;
    }
    if (this.licenciaFechaNacimientoHijo && !fHijo) {
      this.modalErrorDocumento('Fecha de nacimiento del hijo inválida.');
      return false;
    }
    // Si el tipo exige datos del hijo (ej: 4)
    if (String(this.licenciaTipo) === '4' &&
      (!this.licenciaRutHijo || !this.licenciaFechaNacimientoHijo)) {
      this.modalErrorDocumento('Debes completar RUT y fecha de nacimiento del hijo.');
      return false;
    }
    return true;
  }

  private confirmar(titulo: string, onConfirm: () => void) {
    Swal.fire({
      html: `<div style="text-align:center;font-family:Mulish;">
            <h1 style="padding:0 50px;color:#171994;font-weight:bold;font-size:24px;line-height:32px;">${titulo}</h1>
          </div>`,
      showCancelButton: true,
      cancelButtonText: 'Volver',
      confirmButtonText: 'Confirmar',
      buttonsStyling: false,
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn-swal-licencia-confirm',
        cancelButton: 'btn-swal-licencia-cancel',
        popup: 'container-swal-licencia-customer'
      }
    }).then(res => res.isConfirmed && onConfirm());
  }

  solicitarLicencia() {
    // console.log(this.licenciaFechaInicio);
    // console.log();


    this.confirmar('¿Deseas iniciar el proceso de licencia para este paciente?',
      () => this.solicitarLicenciaPost());
  }

  generarLicencia() {
    this.confirmar('¿Deseas generar la licencia para este paciente?',
      () => this.generarLicenciaPost());
  }

  private solicitarLicenciaPost() {
    // console.log(this.licenciaFechaInicio);
    // console.log(this.licenciaFechaNacimientoHijo);

    if (!this.verificarDatosLicencia()) return;

    const fIni: any = this.licenciaFechaInicio;
    // console.log(fIni, 'fIni-solicitarLicenciaPost');

    const fHijo: any = this.licenciaFechaNacimientoHijo
      ? this._generalServices.verificarFecha(this.licenciaFechaNacimientoHijo)
      : null;
    // console.log(fHijo, 'fHijo-solicitarLicenciaPost');

    const rut = this.licenciaRutHijo?.trim() ? this.licenciaRutHijo.trim() : null;


    let fecha: any = this._generalServices.verificarFecha(this.licenciaFechaInicio);
    let fecha_hijo: any = this._generalServices.verificarFecha(this.licenciaFechaNacimientoHijo);
    let rut_hijo = (this.licenciaRutHijo) ? this.licenciaRutHijo : null;
    this.modalCargando();
    this._licenciaService.postRequestMedicalLeave(
      this.licenciaFechaInicio,
      this.licenciaDiagnosticoId,
      this.licenciaDiasReposo,
      this.licenciaTipo,
      rut_hijo,
      this.licenciaFechaNacimientoHijo,
      this.consulta.id_consulta
    )
      .then(() => {
        this.modalAgregadoExitoso();
        this.getDocumentos();
        this.cancelarLicencia();
      })
      .catch(() => this.modalErrorDocumento('Error en la generación de licencia.'));
  }

  private generarLicenciaPost() {
    if (!this.verificarDatosLicencia()) return;

    const fIni = this.licenciaFechaInicio;
    const fHijo = this.licenciaFechaNacimientoHijo;
    const rut = this.licenciaRutHijo?.trim() ? this.licenciaRutHijo.trim() : null;

    this.modalCargando();
    this._licenciaService.postCreateMedicalLeave(
      fIni,
      this.licenciaDiagnosticoId,
      this.licenciaDiasReposo,
      this.licenciaTipo,
      rut,
      fHijo,
      this.consulta.id_consulta
    )
      .then(() => {
        this.modalAgregadoExitoso();
        this.getDocumentos();
        this.cancelarLicencia();
      })
      .catch(() => this.modalErrorDocumento('Error en la generación de licencia.'));
  }


  // VER Y ADJUNTAR

  nombreValido(): boolean {
    // Ajusta la regex a tus reglas. Esta permite letras/números/espacios y algunos símbolos.
    return !!this.nombre_doc?.trim() && /^[\w\s\-\.\(\)\[\]#]+$/.test(this.nombre_doc.trim());
  }

  private getExtensionFromMime(file: File): string | null {
    switch (file.type) {
      case 'application/pdf': return 'pdf';
      case 'image/jpeg': return 'jpg';
      case 'image/png': return 'png';
      default: return null;
    }
  }

  private getExtensionFromName(file: File): string | null {
    const parts = file.name.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : null;
  }

  private buildFinalName(base: string, file: File): string | null {
    // 1) Intentar por MIME, 2) por nombre
    const ext = this.getExtensionFromMime(file) || this.getExtensionFromName(file);
    if (!ext) return null;

    // Evitar doble extensión si ya viene con punto
    const cleanBase = base.trim().replace(/\.+$/, ''); // quita puntos finales
    if (cleanBase.toLowerCase().endsWith('.' + ext)) return cleanBase; // ya venía con extensión correcta
    return `${cleanBase}.${ext}`;
  }


  abrirAgregarDocumento(): void {
    this.agregandoDocumento = true;
    this.nombre_doc = '';
    this.doc = null;
    this.doc_permitido = true;
    this.doc_supera_peso = false;
    this.selectedTabDoc = 'Por los tratantes';
  }

  cancelarDocumento(): void {
    this.agregandoDocumento = false;
    this.nombre_doc = '';
    this.delFileSelected();
  }



  onFileSelected(evt: Event): void {
    const input = evt.target as HTMLInputElement;
    const file = input?.files && input.files.length ? input.files[0] : null;

    this.doc = file;
    if (!file) {
      this.doc_permitido = true;
      this.doc_supera_peso = false;
      return;
    }

    this.doc_permitido = this.tiposPermitidos.includes(file.type);
    this.doc_supera_peso = file.size > this.maxPesoBytes;
  }


  delFileSelected(): void {
    this.doc = null;
    this.doc_permitido = true;
    this.doc_supera_peso = false;
  }


  puedeGuardarDocumento(): boolean {
    return !!this.doc
      && this.doc_permitido
      && !this.doc_supera_peso
      && this.nombreValido()
      && !!this.consulta?.id_consulta
      && !!(this.consulta?.user_id ?? this.consulta?.use_id ?? this.consulta?.pat_use_id);
  }



  guardarDocumento(): void {
    // Mismo flujo que tu guardar_doc, pero para el formulario inline
    if (!this.doc) {
      Swal.fire({ icon: 'info', title: 'Campos Incompletos', text: 'Debe seleccionar un archivo.', timer: 4000 });
      return;
    }

    if (!this.doc_permitido) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Tipo no permitido</h1><br>' +
          ' <p style="font-family:Mulish;font-size:16px;line-height:24px;color:#000;">Solo PDF, JPG o PNG.</p><br>',
      });
      return;
    }

    if (this.doc_supera_peso) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Archivo muy pesado</h1><br>' +
          ' <p style="font-family:Mulish;font-size:16px;line-height:24px;color:#000;">El máximo permitido es 20 MB.</p><br>',
      });
      return;
    }

    if (!this.nombreValido()) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Campos incompletos</h1><br>' +
          ' <p style="font-family:Mulish;font-size:16px;line-height:24px;color:#000;">Ingrese un título válido.</p><br>',
      });
      return;
    }

    const finalName = this.buildFinalName(this.nombre_doc, this.doc);
    if (!finalName) {
      Swal.fire({
        icon: 'warning',
        title: 'Extensión no reconocida',
        text: 'No se pudo determinar la extensión del archivo.',
        timer: 4000
      });
      return;
    }

    const idConsulta = this.consulta.id_consulta;
    const userId = this.consulta.user_id ?? this.consulta.use_id ?? this.consulta.pat_use_id;

    this.modalCargando();

    this._documentServices.postSaveOtro(this.doc, idConsulta, finalName, userId)
      .then(() => {
        this.modalAgregadoExitoso();

        // Refresca listas (paciente y consulta, si usas ambas)
        this.listar_documentos();        // documentos del paciente
        this.listar_archivos_consulta();


        // Reset UI inline (sin cerrar modal)
        this.doc = null;
        this.nombre_doc = '';
        this.doc_permitido = true;
        this.doc_supera_peso = false;
        this.agregandoDocumento = false;
      })
      .catch((error) => {
        console.error('[Docs] Error al subir documento:', error);
        Swal.fire('Error', error?.message || 'No fue posible subir el documento.', 'error');
      });
  }

  listar_archivos_consulta(): void {
    const useId = this.consulta.user_id;

    this._documentServices.postListaArchivosConsulta(this.consulta.id_consulta, useId)
      .then(results => {
        this.archivos_consulta = results;
        // console.log(this.archivos_consulta);

        let ind = 1;
        for (const file of this.archivos_consulta) {
          if (file.file_name) {
            const ind_st = (100 + ind).toString().substring(1);
            file.file_name_desc = file.file_name.replace('XX', ind_st);
            ind++;
            // console.log(file);
            // console.log(ind_st);


          }
        }
      })
      .catch(err => {
        console.error('[Docs] Error listando archivos consulta:', err);
        this.archivos_consulta = [];
      });
  }




  listar_documentos() {
    this.isLoading = true;
    // console.log(this.consulta);

    this._documentServices.postListarArchivosPaciente(this.consulta.user_id)
      .then((results: any) => {

        this.archivos_paciente = results;
        // console.log(this.archivos_paciente);

        this.isLoading = false;

      })
      .catch(error => {
        console.log(error);
      });
  }
  // ------- Filtros "Por el paciente"
  filtroTipoId: number | null = null;      // att_typ_id
  filtroFechaIni: string = '';             // YYYY-MM-DD (input date)
  filtroFechaFin: string = '';

  // Catálogo base (puedes ajustarlo o poblarlo dinámicamente)
  tiposDocPaciente = [
    { id: 14, name: 'OTROS DOCUMENTOS' },
    { id: 12, name: 'RESULTADOS DE EXAMENES' },
    // Si tu backend usa otro id para "IMAGENES", cámbialo aquí:
    { id: 13, name: 'IMAGENES' } // ← ajusta si corresponde
  ];

  cargandoFiltro = false;

  filtrar_documentos(): void {
    this.cargandoFiltro = true;
    const useId = this.consulta?.user_id ?? this.consulta?.use_id ?? this.consulta?.pat_use_id;
    if (!useId) {
      Swal.fire({ icon: 'info', title: 'Falta ID de paciente', timer: 2500 });
      return;
    }

    const f_inicio = this.filtroFechaIni;
    const f_fin = this.filtroFechaFin;

    if (f_inicio && f_fin && f_inicio > f_fin) {
      Swal.fire({
        allowOutsideClick: false,
        html: ' <i class="material-icons" style="color:#171994;font-size:58px;margin:20px 40px 10px;">mood_bad</i><br><br>' +
          ' <h1 style="font-family:Mulish;font-weight:800;font-size:28px;line-height:48px;color:#171994;">Rango de fechas inválido.</h1>' +
          ' <p style="font-family:Mulish;font-size:16px;line-height:24px;color:#000;">La fecha inicio no puede ser mayor a la fecha fin.</p><br>',
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      return;
    }


    this.modalCargando();
    this._documentServices
      .postFiltrarArchivosPaciente(useId, f_inicio, f_fin, this.filtroTipoId ?? null)
      .then((res: any) => {
        Swal.close();
        this.archivos_paciente = Array.isArray(res) ? res : (res?.archivos || res?.data || []);
        this.filtroTipoId = null;
        this.filtroFechaIni = '';
        this.filtroFechaFin = '';
      })
      .finally(() => this.cargandoFiltro = false)
      .catch(err => {
        Swal.close();
        console.error('[Docs] Error al filtrar documentos del paciente:', err);
        Swal.fire({ icon: 'error', title: 'Error al filtrar documentos', timer: 3000 });
      });
  }


  limpiar_filtros_documentos(): void {
    this.filtroTipoId = null;
    this.filtroFechaIni = '';
    this.filtroFechaFin = '';
    this.listar_documentos(); // recarga sin filtros
  }

  // (Opcional) Si quieres poblar los tipos dinámicamente a partir de lo cargado:
  private hydrateTiposDesdeDatos(): void {
    if (!Array.isArray(this.archivos_paciente)) return;
    const map = new Map<number, string>();
    for (const f of this.archivos_paciente) {
      if (f?.att_typ_id != null) map.set(Number(f.att_typ_id), f.att_typ_name || '—');
    }
    const dinamicos = Array.from(map.entries()).map(([id, name]) => ({ id, name }));
    if (dinamicos.length) this.tiposDocPaciente = dinamicos;
  }



  // MODALES
  modalCargando() {
    Swal.fire({
      html: ` <div style="margin: 40px 0;">
                                 <i class="material-icons" style="color:#171994; font-size: 58px; margin-bottom:25px">schedule</i>
                                 <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">Espere por favor...</h1>
                               </div>`,
      showConfirmButton: false,
      allowOutsideClick: false,
      timer: 5000
    })
    Swal.showLoading();
  }

  modalAgregadoExitoso() {
    Swal.close();
    Swal.fire({
      html:
        ' <i class="material-icons" style="color:#171994;font-size: 58px;margin: 20px 40px 10px;">mood</i> <br>' +
        ' <h1 style="font-family: Mulish; font-style: normal; font-weight: 800;font-size: 38px; line-height: 48px; display: flex; align-items: center; text-align: center; color: #171994;" > El documento se ha subido exitosamente</h1><br>',
      // footer: '<button id="buttonInicio" style="border: 2px solid #316AD8;box-sizing: border-box;border-radius: 30px; width: 100%;height: 100%; background: #171994;font-family: Mulish;font-style: normal;font-weight: bold;font-size: 16px; line-height: 24px; align-items: center; text-align: center; color: #FFFFFF;" class="btn btn-outline-primary btn-lg" (click)="navegar()" >Volver al inicio</button> ',
      showCancelButton: false,
      showConfirmButton: false,
      timer: 2000
    })
  }

  modalErrorDocumento(mjs = '') {
    Swal.close();
    let mensaje = 'Error al manejar documento.';
    if (mjs != '') {
      mensaje = mjs;
    }
    Swal.fire({
      icon: 'warning',
      title: mensaje,
      timer: 2000
    })
  }

  // MODALES

  abrirModalEliminar(item: any, tipo: 'diagnostico' | 'receta' | 'certificado' | 'orden' | 'otro' | 'mascota') {
    this.documentoAEliminar = item;
    this.tipoDocumentoAEliminar = tipo;
    this.modalActual = 'confirmacionEliminar';
  }



  mostrarModal(tipo: string) {
    // Muestra el mensaje de carga
    Swal.fire({
      allowOutsideClick: false,
      html: `<div style="margin: 40px 0;">
                                <i class="material-icons" style="color:#171994; font-size: 58px; margin-bottom:25px">schedule</i>
                                <h1 style="font-family: Mulish; font-style: normal; font-weight: 700; font-size: 24px; line-height: 32px; text-align: center; color: #171994;">
                                    Espere por favor...
                                </h1>
                             </div>`,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading(); // Muestra el spinner de carga
      }
    });

  }
  cerrarModal() {
    this.modalActual = null;
    this.documentoAEliminar = null;
    this.tipoDocumentoAEliminar = null;
    document.body.classList.remove("modal-open");
  }

  // YAPP
  private async initRegionComunaYapp(): Promise<void> {
    try {
      const couId = Number(this.consulta?.cou_id || this.usuario?.cou_id || 1);

      await this.cargarRegionesYapp(couId);

      const regId = Number(this.consulta?.reg_id || 0);
      const comId = Number(this.consulta?.com_id || 0);

      if (regId) {
        this.selectedRegionId = regId;
        this.selectedRegionObj = this.regionesYapp.find((r: any) => Number(r.reg_id) === regId) || null;

        await this.cargarComunasYapp(regId);

        if (comId) {
          this.selectedComunaId = comId;
          this.selectedComunaObj = this.comunasYapp.find((c: any) => Number(c.com_id) === comId) || null;
        }
      }

      this.yappCommune = this.resolveCommune();
    } catch (error) {
      console.error('Error inicializando región/comuna YAPP:', error);
    }
  }

  private async cargarRegionesYapp(couId: number): Promise<void> {
    try {
      const resp = await this._usuarioService.getRegiones(couId);
      this.regionesYapp = Array.isArray(resp) ? resp : [];
    } catch (error) {
      console.error('Error al cargar regiones:', error);
      this.regionesYapp = [];
    }
  }

  private async cargarComunasYapp(regId: number): Promise<void> {
    try {
      const resp = await this._usuarioService.getComunas(regId);
      this.comunasYapp = Array.isArray(resp) ? resp : [];
    } catch (error) {
      console.error('Error al cargar comunas:', error);
      this.comunasYapp = [];
    }
  }

  async onRegionYappChange(regionId: any): Promise<void> {
    this.selectedRegionId = regionId != null ? Number(regionId) : null;
    this.selectedRegionObj = this.regionesYapp.find((r: any) => Number(r.reg_id) === Number(this.selectedRegionId)) || null;

    this.selectedComunaId = null;
    this.selectedComunaObj = null;
    this.comunasYapp = [];

    if (this.selectedRegionId) {
      await this.cargarComunasYapp(this.selectedRegionId);
    }

    // mientras no elijan comuna, no actualizar comuna YAPP
    this.yappCommune = this.resolveCommune();
  }

  onComunaYappChange(comunaId: any): void {
    this.selectedComunaId = comunaId != null ? Number(comunaId) : null;
    this.selectedComunaObj = this.comunasYapp.find((c: any) => Number(c.com_id) === Number(this.selectedComunaId)) || null;

    this.yappCommune = this.resolveCommune();
  }

  private getUbicacionYappFinal(): {
    reg_id: number | null;
    reg_name: string | null;
    com_id: number | null;
    com_name: string | null;
    code_yapp: number | null;
  } {
    const regionSeleccionada = this.selectedRegionObj ||
      this.regionesYapp.find((r: any) => Number(r.reg_id) === Number(this.selectedRegionId)) ||
      null;

    const comunaSeleccionada = this.selectedComunaObj ||
      this.comunasYapp.find((c: any) => Number(c.com_id) === Number(this.selectedComunaId)) ||
      null;

    const usoSeleccion = !!(regionSeleccionada || comunaSeleccionada);

    if (usoSeleccion && comunaSeleccionada) {
      return {
        reg_id: regionSeleccionada?.reg_id ? Number(regionSeleccionada.reg_id) : null,
        reg_name: regionSeleccionada?.reg_name || null,
        com_id: comunaSeleccionada?.com_id ? Number(comunaSeleccionada.com_id) : null,
        com_name: comunaSeleccionada?.com_name || null,
        code_yapp: comunaSeleccionada?.code_yapp != null ? Number(comunaSeleccionada.code_yapp) : null
      };
    }

    return {
      reg_id: this.consulta?.reg_id ? Number(this.consulta.reg_id) : null,
      reg_name: this.consulta?.reg_name || null,
      com_id: this.consulta?.com_id ? Number(this.consulta.com_id) : null,
      com_name: this.consulta?.com_name || null,
      code_yapp: this.consulta?.code_yapp != null ? Number(this.consulta.code_yapp) : null
    };
  }
  private resolveCommune(): number {
    const ubicacionFinal = this.getUbicacionYappFinal();

    const raw =
      ubicacionFinal?.code_yapp ??
      this.consulta?.code_yapp ??
      this.consulta?.commune ??
      this.consulta?.com_id ??
      this.consulta?.cus_com_id ??
      this.usuario?.commune ??
      this.usuario?.com_id ??
      this.usuario?.cus_com_id ??
      this.documentos?.commune ??
      this.documentos?.com_id ??
      13101;

    const n = Number(raw);
    return Number.isFinite(n) ? n : 13101;
  }


  onYappQueryChange(value: string) {
    this.yappQuery = value;

    if (!this.mostrarBuscadorYapp()) {
      this.resetYappState();
      return;
    }

    const q = (value || '').trim();

    // Cancelar búsqueda pendiente si todavía no cumple mínimo
    if (this.yappDebounceTimer) {
      clearTimeout(this.yappDebounceTimer);
      this.yappDebounceTimer = null;
    }

    // No llamar servicio hasta tener al menos 3 caracteres
    if (q.length < 3) {
      this.yappResults = [];
      this.yappShowDropdown = false;
      this.yappLoading = false;
      return;
    }

    this.yappDebounceTimer = setTimeout(() => {
      this.buscarYapp(q);
    }, 300);
  }

  private async buscarYapp(q: string) {
    if (!q || q.trim().length < 3) return;

    const commune = this.yappCommune || this.resolveCommune();
    this.yappCommune = commune;

    const currentReq = ++this.yappReqId;
    this.yappLoading = true;
    this.yappShowDropdown = true;

    try {
      const body = {
        q: q.trim(),
        clinicalMedicaments: true,
        commercialProducts: true,
        commune: commune,
        groupCommercialProducts: false,
        patientCode: "053195",
        perPage: 15,
        largeScale: "group",
        cenabast: false
      };

      const resp: any = await this._yappService.productSearch(body);

      if (currentReq !== this.yappReqId) return;

      const arr =
        Array.isArray(resp?.results) ? resp.results :
          Array.isArray(resp?.data) ? resp.data :
            Array.isArray(resp) ? resp :
              [];

      this.yappResults = arr || [];
    } catch (e) {
      if (currentReq !== this.yappReqId) return;
      this.yappResults = [];
    } finally {
      if (currentReq === this.yappReqId) this.yappLoading = false;
    }
  }



  selectYappItem(item: any) {
    const title = this.getYappItemTitle(item);
    const subtitle = this.getYappItemSubtitle(item);

    if (!title) return;

    const ids = this.getYappItemIds(item);

    if (!ids.clinicalIds.length && !ids.commercialIds.length) return;

    const claveUnica = JSON.stringify({
      clinicalIds: ids.clinicalIds,
      commercialIds: ids.commercialIds
    });

    const yaExiste = this.yappSelectedItems.some((x: YappSelectedItem) => {
      const actual = JSON.stringify({
        clinicalIds: x.clinicalIds,
        commercialIds: x.commercialIds
      });
      return actual === claveUnica;
    });

    if (yaExiste) {
      this.yappQuery = '';
      this.yappResults = [];
      this.yappShowDropdown = false;
      return;
    }

    this.yappSelectedItems.push({
      clinicalIds: ids.clinicalIds,
      commercialIds: ids.commercialIds,
      title,
      subtitle,
      indication: ''
    });

    this.yappQuery = '';
    this.yappResults = [];
    this.yappShowDropdown = false;
  }


  onChangeTipoReceta(value: any) {
    this.id_receta = value;

    const recetaSeleccionada = this.recetasFiltradas.find(
      (r: any) => String(r.pre_typ_id) === String(this.id_receta)
    );

    console.log('id_receta:', this.id_receta);
    console.log('recetaSeleccionada:', recetaSeleccionada);

    if (!this.mostrarBuscadorYapp()) {
      this.resetYappState();
    }
  }

  mostrarBuscadorYapp(): boolean {
    return String(this.id_receta) === '1' || String(this.id_receta) === '2' || String(this.id_receta) === '3';
  }

  getYappItemTitle(item: any): string {
    return (
      item?.name ||
      item?.shortDescription ||
      item?.description ||
      item?.label ||
      item?.text ||
      'Medicamento'
    );
  }

  getYappItemSubtitle(item: any): string {
    return (
      item?.brand ||
      item?.laboratorio ||
      item?.laboratory ||
      item?.laboratoryName ||
      item?.presentation ||
      item?.extra ||
      ''
    );
  }

  removeYappItem(index: number) {
    this.yappSelectedItems.splice(index, 1);
  }

  private resetYappState() {
    this.yappQuery = '';
    this.yappResults = [];
    this.yappLoading = false;
    this.yappShowDropdown = false;
    this.yappSelectedItems = [];
  }
  private buildPrescriptionText(): string {
    const medicamentosYapp = this.yappSelectedItems.map((item: YappSelectedItem) => {
      const indicacion = (item.indication || '').trim();
      return indicacion
        ? `${item.title}\nIndicaciones: ${indicacion}`
        : `${item.title}`;
    });

    const textoLibre = (this.prescriptionText || '').trim();

    const bloques: string[] = [];

    if (medicamentosYapp.length) {
      bloques.push(medicamentosYapp.join('\n\n'));
    }

    if (textoLibre) {
      bloques.push(textoLibre);
    }

    return bloques.join('\n\n');
  }

  private getYappSelectedIds(): { clinicos: number[]; comerciales: number[] } {
    const clinicos = this.yappSelectedItems
      .reduce((acc: number[], item: YappSelectedItem) => {
        return acc.concat(item.clinicalIds || []);
      }, [])
      .map((id: any) => Number(id))
      .filter((id: number) => !!id);

    const comerciales = this.yappSelectedItems
      .reduce((acc: number[], item: YappSelectedItem) => {
        return acc.concat(item.commercialIds || []);
      }, [])
      .map((id: any) => Number(id))
      .filter((id: number) => !!id);

    return {
      clinicos: Array.from(new Set(clinicos)),
      comerciales: Array.from(new Set(comerciales))
    };
  }
  private getYappItemIds(item: any): { clinicalIds: number[]; commercialIds: number[] } {
    const clinicalRaw = item?.ids?.clinical_medicament;
    const commercialRaw = item?.ids?.commercial_product;

    const clinicalIds = Array.isArray(clinicalRaw)
      ? clinicalRaw.map((id: any) => Number(id)).filter((id: number) => !!id)
      : clinicalRaw != null
        ? [Number(clinicalRaw)].filter((id: number) => !!id)
        : [];

    // 🔥 NUEVA LÓGICA CLAVE
    let commercialIds: number[] = [];

    if (clinicalIds.length > 0) {
      // 👉 Si es clínico → usar SOLO el primer commercialProductDoses
      const firstDoseId = item?.commercialProductDoses?.[0]?.id;

      if (firstDoseId) {
        commercialIds = [Number(firstDoseId)];
      }
    } else {
      // 👉 Si NO es clínico → usar commercial_product normal
      commercialIds = Array.isArray(commercialRaw)
        ? commercialRaw.map((id: any) => Number(id)).filter((id: number) => !!id)
        : commercialRaw != null
          ? [Number(commercialRaw)].filter((id: number) => !!id)
          : [];
    }

    return {
      clinicalIds,
      commercialIds
    };
  }
}
